<template>
  <div class="page-home">
    <p class="text-center">خانه</p>
    <p class="text-center">در حال تکمیل</p>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {}
  }
}
</script>
